import type { AxiosError } from 'axios';

export function isAxiosError(payload: unknown): payload is AxiosError {
    return (
        !!payload &&
        typeof payload === 'object' &&
        'isAxiosError' in payload &&
        (payload as AxiosError).isAxiosError === true
    );
}
